import { prepareBodyForSplit } from "../utilst";
import { IVoiceType } from "types";
import { IAudioHandles } from "providers/AudioProvider/handleTypes";
import { useState } from "react";
import {
  AudioTrack,
  IAudioState,
  MetadataToSubtitlesLanguages,
} from "providers/AudioProvider/types";

interface UseSubmitProps {
  oneTrack: AudioTrack | undefined;
  captions: string[];
  voice: IVoiceType[] | undefined;
  speed: number[] | undefined;
  subtitleMode: boolean;
  handles: IAudioHandles;
  handleClosePop: () => void;
  state: IAudioState;
}

export const useSubmit = ({
  oneTrack,
  captions,
  voice,
  speed,
  subtitleMode,
  handles,
  handleClosePop,
  state,
}: UseSubmitProps) => {
  const [loading, setLoading] = useState(false);
  const handleSubmit = async () => {
    if (!oneTrack) {
      return;
    }
    setLoading(true);
    // Пустая строка окна — не кусок (fdcde2a1, 01.10.2026, папка 2): «…поведению.⏎⏎Зависимости…⏎»
    // давало куски без русского текста, а машинный перевод падал на них ValueError. Остался
    // один кусок с текстом — это правка текста, а не разбиение.
    const pieces = textPieces(captions);
    if (pieces.length <= 1) {
      const text = pieces[0] ?? "";
      if (
        removeEdgeLineBreaks(text) !== oneTrack["captions"] ||
        voice?.[0] !== oneTrack["voice"] ||
        speed?.[0] !== oneTrack["speed"]
      ) {
        if (subtitleMode) {
          void handles.editRusSubtitle({
            track: oneTrack,
            captions: text,
            lang: MetadataToSubtitlesLanguages[state.originalLang],
          });
          handleClosePop();
        } else {
          // TODO heree sved merge and split change to new api and in state
          // saveCaptionsBreak(
          //   oneTrack,
          //   captions[0],
          //   voice?.[0] || "",
          //   (speed?.[0] || 0).toString(),
          //   (background?.[0]).toString(),
          //   { state, handles },
          // );
        }
      }
    } else {
      if (subtitleMode) {
        const body = prepareBodyForSplit({
          oneTrack,
          captions: pieces,
          captionsField: "captions",
        });
        await handles.splitRusSubtitle(body);
        handleClosePop();
      } else {
        // TODO heree sved merge and split change to new api and in state
        // saveCaptionsBreak(oneTrack, captions[0], voice[0], speed[0], background, { state, handles });
      }
    }
    setLoading(false);
  };

  return { handleSubmit, loading };
};

/** Куски разбиения — строки окна, в которых есть текст; пустые и из одних пробелов отбрасываются. */
export const textPieces = (captions: string[]) => captions.filter((one) => (one || "").trim() !== "");

const removeEdgeLineBreaks = (text: string) => {
  return text ? text.replace(/^\s*[\r\n]+|[\r\n]+\s*$/g, "") : "";
};
